import { useEffect, useState } from 'react'
import { ConsentSnapshot, getConsentSnapshot, subscribe } from '../lib/analyticsConsent'

/** Live consent state for the UI. */
export function useAnalyticsConsent(): ConsentSnapshot {
  const [snapshot, setSnapshot] = useState<ConsentSnapshot>(getConsentSnapshot)
  useEffect(() => subscribe(() => setSnapshot(getConsentSnapshot())), [])
  return snapshot
}
